import styled from 'styled-components';

export const ModalBackground = styled.div`
    width: 100%;
    padding: 100px 0;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    // display: flex;
    // justify-content: center;
    // align-items: center;
    background-color: rgba(0, 0, 0, 0.9);
    overflow: scroll;
    max-height: 100%;
    overflow-y: auto;
    z-index: 999999;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
`;

export const ModalContentWrapper = styled.div`
    display: flex;
    justify-content: center;
`;



// WEBPACK FOOTER //
// ./src/UI/Containers/Modals/style.js